import { CustomAutocomplete } from "../../../../components/custom-autocomplete.component";
import { CustomAutocompleteShadcn } from "../../../../components/custom-autocomplete-shadcn.component";
import { SelectProps } from "../../../form-types";
import { countryOptions } from "@/dentlab/src/lib/constants/countries";

export const CountrySelect: React.FC<SelectProps> = (props) => {
	return (
		<CustomAutocomplete
			options={countryOptions}
			inputLabel="Land"
			{...props}
		/>
	);
};

export const CountrySelectShadcn: React.FC<
	SelectProps & { invalid?: boolean }
> = (props) => {
	return (
		<CustomAutocompleteShadcn
			options={countryOptions}
			inputLabel="Land"
			{...props}
		/>
	);
};
